module.exports = __webpack_public_path__ + "static/media/marbles.c6181775.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marbles.svg
// module id = 879
// module chunks = 0